/**
 * @file Home.
 */

/* global FWP */

/**
 * Home functions.
 *
 * Runs js specific to the Home template.
 */
const vHome = () => {
	const hero = document.querySelector('.v-blog-hero');
	const featured = document.querySelector('.v-listing-columns');
	const filters = document.querySelector('.v-filter-bar');

	if (!window.FWP) {
		return;
	}

	let wasPage = 1;

	document.addEventListener('facetwp-loaded', () => {
		if (FWP.settings.pager.page > 1) {
			hero.classList.add('v-blog-hero--no-featured');
			featured.classList.add('v-listing-columns--hide');
		} else {
			hero.classList.remove('v-blog-hero--no-featured');
			featured.classList.remove('v-listing-columns--hide');
		}

		if (FWP.settings.pager.page !== wasPage) {
			const headerHeight = parseInt(
				getComputedStyle(document.documentElement)
					.getPropertyValue('--header-height')
					.replace('px', ''),
				10,
			);
			window.scrollTo({
				top:
					filters.getBoundingClientRect().top + window.scrollY - headerHeight,
			});
		}
		wasPage = FWP.settings.pager.page;
	});

	document.addEventListener('facetwp-refresh', () => {
		if (FWP.soft_refresh === true) {
			FWP.enable_scroll = true;
		} else {
			FWP.enable_scroll = false;
		}

		if (FWP.enable_scroll === true) {
			const headerHeight = parseInt(
				getComputedStyle(document.documentElement)
					.getPropertyValue('--header-height')
					.replace('px', ''),
				10,
			);
			window.scrollTo({
				top:
					filters.getBoundingClientRect().top + window.scrollY - headerHeight,
			});
		}
	});
};

if (document.readyState !== 'loading') {
	vHome();
} else {
	document.addEventListener('DOMContentLoaded', vHome);
}
